export default {
    backgroundColor: {
        "vector-layer-06": "var(--color-background-vector-layer-06)",
        "vector-layer-05": "var(--color-background-vector-layer-05)",
        "vector-layer-04": "var(--color-background-vector-layer-04)",
        "vector-layer-03": "var(--color-background-vector-layer-03)",
        "vector-layer-02": "var(--color-background-vector-layer-02)",
        "vector-layer-01": "var(--color-background-vector-layer-01)",
        "trading-account-06-solid": "var(--color-background-trading-account-06-solid)",
        "trading-account-06": "var(--color-background-trading-account-06)",
        "trading-account-05-solid": "var(--color-background-trading-account-05-solid)",
        "trading-account-05": "var(--color-background-trading-account-05)",
        "trading-account-04-solid": "var(--color-background-trading-account-04-solid)",
        "trading-account-04": "var(--color-background-trading-account-04)",
        "trading-account-03-solid": "var(--color-background-trading-account-03-solid)",
        "trading-account-03": "var(--color-background-trading-account-03)",
        "trading-account-02-solid": "var(--color-background-trading-account-02-solid)",
        "trading-account-02": "var(--color-background-trading-account-02)",
        "trading-account-01-solid": "var(--color-background-trading-account-01-solid)",
        "trading-account-01": "var(--color-background-trading-account-01)",
        "trading-options-03": "var(--color-background-trading-options-03)",
        "trading-options-02": "var(--color-background-trading-options-02)",
        "trading-options-01": "var(--color-background-trading-options-01)",
        "interaction-popover": "var(--color-background-interaction-popover)",
        "interaction-tag-disabled": "var(--color-background-interaction-tag-disabled)",
        "interaction-tag": "var(--color-background-interaction-tag)",
        "interaction-item-selected": "var(--color-background-interaction-item-selected)",
        "interaction-item-hovered": "var(--color-background-interaction-item-hovered)",
        "interaction-knob-disabled": "var(--color-background-interaction-knob-disabled)",
        "interaction-knob-selected": "var(--color-background-interaction-knob-selected)",
        "interaction-knob": "var(--color-background-interaction-knob)",
        "interaction-segment-selected": "var(--color-background-interaction-segment-selected)",
        "interaction-segment-hovered": "var(--color-background-interaction-segment-hovered)",
        "interaction-toggle-selected": "var(--color-background-interaction-toggle-selected)",
        "interaction-toggle-hovered": "var(--color-background-interaction-toggle-hovered)",
        "interaction-toggle": "var(--color-background-interaction-toggle)",
        "interaction-control-selected-accent": "var(--color-background-interaction-control-selected-accent)",
        "interaction-control-selected": "var(--color-background-interaction-control-selected)",
        "interaction-control-hovered-accent": "var(--color-background-interaction-control-hovered-accent)",
        "interaction-control-hovered": "var(--color-background-interaction-control-hovered)",
        "interaction-field-disabled": "var(--color-background-interaction-field-disabled)",
        "interaction-field-inverted": "var(--color-background-interaction-field-inverted)",
        "interaction-field-selected": "var(--color-background-interaction-field-selected)",
        "interaction-field-hovered": "var(--color-background-interaction-field-hovered)",
        "interaction-field": "var(--color-background-interaction-field)",
        "button-disabled": "var(--color-background-button-disabled)",
        "button-brand-hovered": "var(--color-background-button-brand-hovered)",
        "button-brand": "var(--color-background-button-brand)",
        "button-gold-hovered": "var(--color-background-button-gold-hovered)",
        "button-gold": "var(--color-background-button-gold)",
        "button-orange-hovered": "var(--color-background-button-orange-hovered)",
        "button-orange": "var(--color-background-button-orange)",
        "button-red-hovered": "var(--color-background-button-red-hovered)",
        "button-red": "var(--color-background-button-red)",
        "button-green-hovered": "var(--color-background-button-green-hovered)",
        "button-green": "var(--color-background-button-green)",
        "button-blue-hovered": "var(--color-background-button-blue-hovered)",
        "button-blue": "var(--color-background-button-blue)",
        "button-inverted-hovered": "var(--color-background-button-inverted-hovered)",
        "button-inverted": "var(--color-background-button-inverted)",
        "button-primary-hovered": "var(--color-background-button-primary-hovered)",
        "button-primary": "var(--color-background-button-primary)",
        "accent-purple-alpha-02": "var(--color-background-accent-purple-alpha-02)",
        "accent-purple-alpha-01": "var(--color-background-accent-purple-alpha-01)",
        "accent-purple-03": "var(--color-background-accent-purple-03)",
        "accent-purple-02": "var(--color-background-accent-purple-02)",
        "accent-purple-01": "var(--color-background-accent-purple-01)",
        "accent-gold-alpha-02": "var(--color-background-accent-gold-alpha-02)",
        "accent-gold-alpha-01": "var(--color-background-accent-gold-alpha-01)",
        "accent-gold-03": "var(--color-background-accent-gold-03)",
        "accent-gold-02": "var(--color-background-accent-gold-02)",
        "accent-gold-01": "var(--color-background-accent-gold-01)",
        "accent-orange-alpha-02": "var(--color-background-accent-orange-alpha-02)",
        "accent-orange-alpha-01": "var(--color-background-accent-orange-alpha-01)",
        "accent-orange-03": "var(--color-background-accent-orange-03)",
        "accent-orange-02": "var(--color-background-accent-orange-02)",
        "accent-orange-01": "var(--color-background-accent-orange-01)",
        "accent-red-alpha-03": "var(--color-background-accent-red-alpha-03)",
        "accent-red-alpha-02": "var(--color-background-accent-red-alpha-02)",
        "accent-red-alpha-01": "var(--color-background-accent-red-alpha-01)",
        "accent-red-03": "var(--color-background-accent-red-03)",
        "accent-red-02": "var(--color-background-accent-red-02)",
        "accent-red-01": "var(--color-background-accent-red-01)",
        "accent-green-alpha-03": "var(--color-background-accent-green-alpha-03)",
        "accent-green-alpha-02": "var(--color-background-accent-green-alpha-02)",
        "accent-green-alpha-01": "var(--color-background-accent-green-alpha-01)",
        "accent-green-03": "var(--color-background-accent-green-03)",
        "accent-green-02": "var(--color-background-accent-green-02)",
        "accent-green-01": "var(--color-background-accent-green-01)",
        "accent-blue-alpha-03": "var(--color-background-accent-blue-alpha-03)",
        "accent-blue-alpha-02": "var(--color-background-accent-blue-alpha-02)",
        "accent-blue-alpha-01": "var(--color-background-accent-blue-alpha-01)",
        "accent-blue-03": "var(--color-background-accent-blue-03)",
        "accent-blue-02": "var(--color-background-accent-blue-02)",
        "accent-blue-01": "var(--color-background-accent-blue-01)",
        "general-blanket-subtle": "var(--color-background-general-blanket-subtle)",
        "general-blanket": "var(--color-background-general-blanket)",
        "general-surface-inverted": "var(--color-background-general-surface-inverted)",
        "general-surface-white": "var(--color-background-general-surface-white)",
        "general-surface-strong": "var(--color-background-general-surface-strong)",
        "general-surface-sunken-alt": "var(--color-background-general-surface-sunken-alt)",
        "general-surface-sunken": "var(--color-background-general-surface-sunken)",
        "general-surface-glass-sunken": "var(--color-background-general-surface-glass-sunken)",
        "general-surface-glass": "var(--color-background-general-surface-glass)",
        "general-surface-alpha-03": "var(--color-background-general-surface-alpha-03)",
        "general-surface-alpha-02": "var(--color-background-general-surface-alpha-02)",
        "general-surface-alpha-01": "var(--color-background-general-surface-alpha-01)",
        "general-surface-03-deepest": "var(--color-background-general-surface-03-deepest)",
        "general-surface-03-deeper": "var(--color-background-general-surface-03-deeper)",
        "general-surface-03": "var(--color-background-general-surface-03)",
        "general-surface-02-deepest": "var(--color-background-general-surface-02-deepest)",
        "general-surface-02-raised": "var(--color-background-general-surface-02-raised)",
        "general-surface-02": "var(--color-background-general-surface-02)",
        "general-surface-01-deepest": "var(--color-background-general-surface-01-deepest)",
        "general-surface-01-deeper": "var(--color-background-general-surface-01-deeper)",
        "general-surface-01": "var(--color-background-general-surface-01)",
        "general-body": "var(--color-background-general-body)",
        "theoretical-chart-loss": "var(--color-background-theoretical-chart-loss)",
        "theoretical-chart-profit": "var(--color-background-theoretical-chart-profit)",
        "status-no-connection": "var(--color-background-status-no-connection)",
        "status-partial-connection": "var(--color-background-status-partial-connection)",
        "status-full-connection": "var(--color-background-status-full-connection)",
        "market-health-downtick": "var(--color-background-market-health-downtick)",
        "market-health-uptick": "var(--color-background-market-health-uptick)",
        "micro-indicator-working": "var(--color-background-micro-indicator-working)",
        "micro-indicator-position": "var(--color-background-micro-indicator-position)",
        "flags-working": "var(--color-background-flags-working)",
        "flags-position": "var(--color-background-flags-position)",
        "order-summary-pairs": "var(--color-background-order-summary-pairs)",
        "order-summary-one-cancel-order": "var(--color-background-order-summary-one-cancel-order)",
        "order-summary-stop-loss": "var(--color-background-order-summary-stop-loss)",
        "order-summary-close-at-profit": "var(--color-background-order-summary-close-at-profit)",
        "order-summary-order-entry": "var(--color-background-order-summary-order-entry)",
        "trading-objective-inactive": "var(--color-background-trading-objective-inactive)",
        "trading-objective-unselected": "var(--color-background-trading-objective-unselected)",
        "trading-objective-selected": "var(--color-background-trading-objective-selected)",
        "toggle-switch-active": "var(--color-background-toggle-switch-active)",
        "toggle-switch-inactive": "var(--color-background-toggle-switch-inactive)",
        "toggle-background-active": "var(--color-background-toggle-background-active)",
        "toggle-background-inactive": "var(--color-background-toggle-background-inactive)",
        "table-table-highlight-green": "var(--color-background-table-table-highlight-green)",
        "table-table-highlight-red": "var(--color-background-table-table-highlight-red)",
        "table-table-highlight-blue": "var(--color-background-table-table-highlight-blue)",
        "table-options-day-cell": "var(--color-background-table-options-day-cell)",
        "table-daily-move-range": "var(--color-background-table-daily-move-range)",
        "table-expected-move-range": "var(--color-background-table-expected-move-range)",
        "table-options-non-regular-expiration": "var(--color-background-table-options-non-regular-expiration)",
        "table-options-regular-expiration": "var(--color-background-table-options-regular-expiration)",
        "table-options-selected-expiration": "var(--color-background-table-options-selected-expiration)",
        "table-grouped-position-expanded-row": "var(--color-background-table-grouped-position-expanded-row)",
        "table-grouped-position-expanded": "var(--color-background-table-grouped-position-expanded)",
        "table-ungrouped-position-row": "var(--color-background-table-ungrouped-position-row)",
        "table-totals-row": "var(--color-background-table-totals-row)",
        "table-column-pill-locked": "var(--color-background-table-column-pill-locked)",
        "table-column-pill": "var(--color-background-table-column-pill)",
        "table-column-header": "var(--color-background-table-column-header)",
        "slider-sell": "var(--color-background-slider-sell)",
        "slider-buy": "var(--color-background-slider-buy)",
        "slider-sell-header": "var(--color-background-slider-sell-header)",
        "slider-buy-header": "var(--color-background-slider-buy-header)",
        "slider-slider-handle": "var(--color-background-slider-slider-handle)",
        "slider-range-deselected": "var(--color-background-slider-range-deselected)",
        "slider-range-selected": "var(--color-background-slider-range-selected)",
        "sidebar-watchlist": "var(--color-background-sidebar-watchlist)",
        "security-pill-change-downtick": "var(--color-background-security-pill-change-downtick)",
        "security-pill-change-uptick": "var(--color-background-security-pill-change-uptick)",
        "security-pill-last-downtick": "var(--color-background-security-pill-last-downtick)",
        "security-pill-last-uptick": "var(--color-background-security-pill-last-uptick)",
        "security-pill-secondary": "var(--color-background-security-pill-secondary)",
        "security-pill-primary": "var(--color-background-security-pill-primary)",
        "modal-blackout": "var(--color-background-modal-blackout)",
        "modal-section-header": "var(--color-background-modal-section-header)",
        "modal-primary-background": "var(--color-background-modal-primary-background)",
        "mid-nat-range-dot": "var(--color-background-mid-nat-range-dot)",
        "mid-nat-range-neutral": "var(--color-background-mid-nat-range-neutral)",
        "mid-nat-range-positive": "var(--color-background-mid-nat-range-positive)",
        "mid-nat-range-negative": "var(--color-background-mid-nat-range-negative)",
        "input-field-text-input": "var(--color-background-input-field-text-input)",
        "input-field-trade-ticket-field": "var(--color-background-input-field-trade-ticket-field)",
        "input-field-header-search": "var(--color-background-input-field-header-search)",
        "input-field-dropdown-disabled": "var(--color-background-input-field-dropdown-disabled)",
        "input-field-dropdown-secondary": "var(--color-background-input-field-dropdown-secondary)",
        "input-field-dropdown-primary": "var(--color-background-input-field-dropdown-primary)",
        "input-field-mutator-controls": "var(--color-background-input-field-mutator-controls)",
        "indicator-order-chain-stats-inactive": "var(--color-background-indicator-order-chain-stats-inactive)",
        "indicator-order-chain-stats-active": "var(--color-background-indicator-order-chain-stats-active)",
        "indicator-non-standard": "var(--color-background-indicator-non-standard)",
        "indicator-after-market": "var(--color-background-indicator-after-market)",
        "indicator-autotrade": "var(--color-background-indicator-autotrade)",
        "indicator-earnings": "var(--color-background-indicator-earnings)",
        "indicator-dividend": "var(--color-background-indicator-dividend)",
        "indicator-trading-halted": "var(--color-background-indicator-trading-halted)",
        "indicator-itm-danger": "var(--color-background-indicator-itm-danger)",
        "indicator-itm": "var(--color-background-indicator-itm)",
        "event-marker-earnings": "var(--color-background-event-marker-earnings)",
        "event-marker-dividend": "var(--color-background-event-marker-dividend)",
        "edit-table-tile-unocked": "var(--color-background-edit-table-tile-unocked)",
        "edit-table-tile-locked": "var(--color-background-edit-table-tile-locked)",
        "edit-table-modal-section-label": "var(--color-background-edit-table-modal-section-label)",
        "curve-mode-strike": "var(--color-background-curve-mode-strike)",
        "curve-mode-hover": "var(--color-background-curve-mode-hover)",
        "curve-mode-highlight": "var(--color-background-curve-mode-highlight)",
        "curve-mode-sell": "var(--color-background-curve-mode-sell)",
        "curve-mode-buy": "var(--color-background-curve-mode-buy)",
        "color-theme-picker-dark-orange": "var(--color-background-color-theme-picker-dark-orange)",
        "color-theme-picker-orange": "var(--color-background-color-theme-picker-orange)",
        "color-theme-picker-dark-tan": "var(--color-background-color-theme-picker-dark-tan)",
        "color-theme-picker-tan": "var(--color-background-color-theme-picker-tan)",
        "color-theme-picker-dark-pink": "var(--color-background-color-theme-picker-dark-pink)",
        "color-theme-picker-pink": "var(--color-background-color-theme-picker-pink)",
        "color-theme-picker-dark-purple": "var(--color-background-color-theme-picker-dark-purple)",
        "color-theme-picker-purple": "var(--color-background-color-theme-picker-purple)",
        "color-theme-picker-dark-blue": "var(--color-background-color-theme-picker-dark-blue)",
        "color-theme-picker-blue": "var(--color-background-color-theme-picker-blue)",
        "color-theme-picker-dark-green": "var(--color-background-color-theme-picker-dark-green)",
        "color-theme-picker-green": "var(--color-background-color-theme-picker-green)",
        "color-theme-picker-dark-gold": "var(--color-background-color-theme-picker-dark-gold)",
        "color-theme-picker-gold": "var(--color-background-color-theme-picker-gold)",
        "color-theme-picker-dark-red": "var(--color-background-color-theme-picker-dark-red)",
        "color-theme-picker-red": "var(--color-background-color-theme-picker-red)",
        "cap-req-analysis-loss": "var(--color-background-cap-req-analysis-loss)",
        "cap-req-analysis-gain": "var(--color-background-cap-req-analysis-gain)",
        "cap-req-other": "var(--color-background-cap-req-other)",
        "cap-req-bonds": "var(--color-background-cap-req-bonds)",
        "cap-req-crypto": "var(--color-background-cap-req-crypto)",
        "cap-req-futures": "var(--color-background-cap-req-futures)",
        "cap-req-options": "var(--color-background-cap-req-options)",
        "cap-req-stocks": "var(--color-background-cap-req-stocks)",
        "button-group-selected": "var(--color-background-button-group-selected)",
        "button-group-deselected": "var(--color-background-button-group-deselected)",
        "banner-selected-positions": "var(--color-background-banner-selected-positions)",
        "analyst-consensus-strong-sell-alpha": "var(--color-background-analyst-consensus-strong-sell-alpha)",
        "analyst-consensus-sell-alpha": "var(--color-background-analyst-consensus-sell-alpha)",
        "analyst-consensus-hold-alpha": "var(--color-background-analyst-consensus-hold-alpha)",
        "analyst-consensus-buy-alpha": "var(--color-background-analyst-consensus-buy-alpha)",
        "analyst-consensus-strong-buy-alpha": "var(--color-background-analyst-consensus-strong-buy-alpha)",
        "analyst-consensus-strong-sell": "var(--color-background-analyst-consensus-strong-sell)",
        "analyst-consensus-sell": "var(--color-background-analyst-consensus-sell)",
        "analyst-consensus-hold": "var(--color-background-analyst-consensus-hold)",
        "analyst-consensus-buy": "var(--color-background-analyst-consensus-buy)",
        "analyst-consensus-strong-buy": "var(--color-background-analyst-consensus-strong-buy)",
        "alert-confirmation": "var(--color-background-alert-confirmation)",
        "alert-information": "var(--color-background-alert-information)",
        "alert-reminder": "var(--color-background-alert-reminder)",
        "alert-order-canceled": "var(--color-background-alert-order-canceled)",
        "alert-order-working": "var(--color-background-alert-order-working)",
        "alert-info": "var(--color-background-alert-info)",
        "alert-error": "var(--color-background-alert-error)",
        "alert-success": "var(--color-background-alert-success)",
        "accounts-black": "var(--color-background-accounts-black)",
        "accounts-gold": "var(--color-background-accounts-gold)",
        "accounts-blue": "var(--color-background-accounts-blue)",
        "accounts-orange": "var(--color-background-accounts-orange)",
        "accounts-purple": "var(--color-background-accounts-purple)",
        "accounts-pink": "var(--color-background-accounts-pink)",
        "accordion-body-expanded": "var(--color-background-accordion-body-expanded)",
        "accordion-header": "var(--color-background-accordion-header)",
        "button-upgrade": "var(--color-background-button-upgrade)",
        "button-login": "var(--color-background-button-login)",
        "button-institution-badge": "var(--color-background-button-institution-badge)",
        "button-view-order": "var(--color-background-button-view-order)",
        "button-order-status-other": "var(--color-background-button-order-status-other)",
        "button-order-status-working": "var(--color-background-button-order-status-working)",
        "button-order-status-filled": "var(--color-background-button-order-status-filled)",
        "button-order-status-cancelled": "var(--color-background-button-order-status-cancelled)",
        "button-asset-type": "var(--color-background-button-asset-type)",
        "button-review-and-send": "var(--color-background-button-review-and-send)",
        "button-continue": "var(--color-background-button-continue)",
        "button-put": "var(--color-background-button-put)",
        "button-sell": "var(--color-background-button-sell)",
        "button-cancel": "var(--color-background-button-cancel)",
        "button-call": "var(--color-background-button-call)",
        "button-buy": "var(--color-background-button-buy)",
        "button-confirmation": "var(--color-background-button-confirmation)",
        "button-inactive": "var(--color-background-button-inactive)",
        "button-default": "var(--color-background-button-default)",
        "general-primary-surface-90": "var(--color-background-general-primary-surface-90)",
        "general-secondary-surface-90": "var(--color-background-general-secondary-surface-90)",
        "general-tertiary-surface-40": "var(--color-background-general-tertiary-surface-40)",
        "general-confirmation": "var(--color-background-general-confirmation)",
        "general-scrollbar": "var(--color-background-general-scrollbar)",
        "general-overlay": "var(--color-background-general-overlay)",
        "general-neutral-movement-2": "var(--color-background-general-neutral-movement-2)",
        "general-neutral-movement": "var(--color-background-general-neutral-movement)",
        "general-negative-movement-2": "var(--color-background-general-negative-movement-2)",
        "general-negative-movement": "var(--color-background-general-negative-movement)",
        "general-positive-movement-2": "var(--color-background-general-positive-movement-2)",
        "general-positive-movement": "var(--color-background-general-positive-movement)",
        "general-tertiary-surface": "var(--color-background-general-tertiary-surface)",
        "general-secondary-surface-contrast": "var(--color-background-general-secondary-surface-contrast)",
        "general-secondary-surface": "var(--color-background-general-secondary-surface)",
        "general-primary-surface": "var(--color-background-general-primary-surface)",
        "general-primary-background": "var(--color-background-general-primary-background)",
    },
    textColor: {
        "icon-semantic-account-06": "var(--color-text-icon-semantic-account-06)",
        "icon-semantic-account-05": "var(--color-text-icon-semantic-account-05)",
        "icon-semantic-account-04": "var(--color-text-icon-semantic-account-04)",
        "icon-semantic-account-03": "var(--color-text-icon-semantic-account-03)",
        "icon-semantic-account-02": "var(--color-text-icon-semantic-account-02)",
        "icon-semantic-account-01": "var(--color-text-icon-semantic-account-01)",
        "icon-semantic-link-hovered": "var(--color-text-icon-semantic-link-hovered)",
        "icon-semantic-link": "var(--color-text-icon-semantic-link)",
        "icon-general-purple-inverted": "var(--color-text-icon-general-purple-inverted)",
        "icon-general-purple-subtle": "var(--color-text-icon-general-purple-subtle)",
        "icon-general-purple": "var(--color-text-icon-general-purple)",
        "icon-general-gold-inverted": "var(--color-text-icon-general-gold-inverted)",
        "icon-general-gold-subtle": "var(--color-text-icon-general-gold-subtle)",
        "icon-general-gold": "var(--color-text-icon-general-gold)",
        "icon-general-orange-inverted": "var(--color-text-icon-general-orange-inverted)",
        "icon-general-orange-subtle": "var(--color-text-icon-general-orange-subtle)",
        "icon-general-orange": "var(--color-text-icon-general-orange)",
        "icon-general-red-inverted": "var(--color-text-icon-general-red-inverted)",
        "icon-general-red-subtle": "var(--color-text-icon-general-red-subtle)",
        "icon-general-red": "var(--color-text-icon-general-red)",
        "icon-general-green-inverted": "var(--color-text-icon-general-green-inverted)",
        "icon-general-green-subtle": "var(--color-text-icon-general-green-subtle)",
        "icon-general-green": "var(--color-text-icon-general-green)",
        "icon-general-blue-inverted": "var(--color-text-icon-general-blue-inverted)",
        "icon-general-blue-subtle": "var(--color-text-icon-general-blue-subtle)",
        "icon-general-blue": "var(--color-text-icon-general-blue)",
        "icon-general-static-black": "var(--color-text-icon-general-static-black)",
        "icon-general-static-white": "var(--color-text-icon-general-static-white)",
        "icon-general-inverted": "var(--color-text-icon-general-inverted)",
        "icon-general-subtle": "var(--color-text-icon-general-subtle)",
        "icon-general-disabled": "var(--color-text-icon-general-disabled)",
        "icon-general-secondary": "var(--color-text-icon-general-secondary)",
        "icon-general-primary": "var(--color-text-icon-general-primary)",
        "indicator-halted": "var(--color-text-indicator-halted)",
        "status-no-connection": "var(--color-text-status-no-connection)",
        "status-partial-connection": "var(--color-text-status-partial-connection)",
        "status-full-connection": "var(--color-text-status-full-connection)",
        "trading-selected-strike": "var(--color-text-trading-selected-strike)",
        "trading-closed-expiration-row": "var(--color-text-trading-closed-expiration-row)",
        "trading-opened-expiration-row": "var(--color-text-trading-opened-expiration-row)",
        "navigation-page-label-inactive": "var(--color-text-navigation-page-label-inactive)",
        "navigation-page-label-active": "var(--color-text-navigation-page-label-active)",
        "input-fields-input-character-count": "var(--color-text-input-fields-input-character-count)",
        "input-fields-input-placeholder": "var(--color-text-input-fields-input-placeholder)",
        "input-fields-input-active": "var(--color-text-input-fields-input-active)",
        "indicators-volume-value": "var(--color-text-indicators-volume-value)",
        "indicators-dark-label": "var(--color-text-indicators-dark-label)",
        "indicators-light-label": "var(--color-text-indicators-light-label)",
        "button-inactive": "var(--color-text-button-inactive)",
        "button-colored": "var(--color-text-button-colored)",
        "button-primary": "var(--color-text-button-primary)",
        "general-note-warning": "var(--color-text-general-note-warning)",
        "general-action": "var(--color-text-general-action)",
        "general-ivr": "var(--color-text-general-ivr)",
        "general-short": "var(--color-text-general-short)",
        "general-long": "var(--color-text-general-long)",
        "general-navigation-active": "var(--color-text-general-navigation-active)",
        "general-debit": "var(--color-text-general-debit)",
        "general-credit": "var(--color-text-general-credit)",
        "general-hyperlink": "var(--color-text-general-hyperlink)",
        "general-inverted-text": "var(--color-text-general-inverted-text)",
        "general-rolling": "var(--color-text-general-rolling)",
        "general-watchlist-ticker": "var(--color-text-general-watchlist-ticker)",
        "general-same-tick": "var(--color-text-general-same-tick)",
        "general-negative-tick": "var(--color-text-general-negative-tick)",
        "general-positive-tick": "var(--color-text-general-positive-tick)",
        "general-descriptive-text": "var(--color-text-general-descriptive-text)",
        "general-inactive-text": "var(--color-text-general-inactive-text)",
        "general-secondary-label": "var(--color-text-general-secondary-label)",
        "general-primary-label": "var(--color-text-general-primary-label)",
        "general-secondary-text-contrast": "var(--color-text-general-secondary-text-contrast)",
        "general-secondary-text": "var(--color-text-general-secondary-text)",
        "general-static-white-text": "var(--color-text-general-static-white-text)",
        "general-primary-text": "var(--color-text-general-primary-text)",
        "general-default-text": "var(--color-text-general-default-text)",
        "alerts-reminder": "var(--color-text-alerts-reminder)",
        "alerts-pending": "var(--color-text-alerts-pending)",
        "alerts-warning": "var(--color-text-alerts-warning)",
        "alerts-error": "var(--color-text-alerts-error)",
        "alerts-information": "var(--color-text-alerts-information)",
        "alerts-confirmation": "var(--color-text-alerts-confirmation)",
    },
    iconColor: {
        "icon-order-chains-loss": "var(--color-icon-order-chains-loss)",
        "icon-order-chains-win": "var(--color-icon-order-chains-win)",
        "icon-order-chains-closed": "var(--color-icon-order-chains-closed)",
        "icon-order-chains-open": "var(--color-icon-order-chains-open)",
        "icon-skill-set-novice": "var(--color-icon-skill-set-novice)",
        "icon-skill-set-intermediate": "var(--color-icon-skill-set-intermediate)",
        "icon-skill-set-expert": "var(--color-icon-skill-set-expert)",
        "icon-trading-stale": "var(--color-icon-trading-stale)",
        "icon-trading-fresh": "var(--color-icon-trading-fresh)",
        "icon-trading-mutators": "var(--color-icon-trading-mutators)",
        "icon-trading-pending-trade": "var(--color-icon-trading-pending-trade)",
        "icon-trading-set-up-trade": "var(--color-icon-trading-set-up-trade)",
        "icon-symbol-detail-iv-rank-circle-empty": "var(--color-icon-symbol-detail-iv-rank-circle-empty)",
        "icon-symbol-detail-iv-rank-circle-filled": "var(--color-icon-symbol-detail-iv-rank-circle-filled)",
        "icon-symbol-detail-liquidity-star-empty": "var(--color-icon-symbol-detail-liquidity-star-empty)",
        "icon-symbol-detail-liquidity-star-filled": "var(--color-icon-symbol-detail-liquidity-star-filled)",
        "icon-radio-button-inactive": "var(--color-icon-radio-button-inactive)",
        "icon-radio-button-active": "var(--color-icon-radio-button-active)",
        "icon-position-type-option": "var(--color-icon-position-type-option)",
        "icon-position-type-stock": "var(--color-icon-position-type-stock)",
        "icon-paginator-active": "var(--color-icon-paginator-active)",
        "icon-paginator-inactive": "var(--color-icon-paginator-inactive)",
        "icon-order-status-long": "var(--color-icon-order-status-long)",
        "icon-order-status-position": "var(--color-icon-order-status-position)",
        "icon-order-status-short": "var(--color-icon-order-status-short)",
        "icon-order-status-expired": "var(--color-icon-order-status-expired)",
        "icon-order-status-rejected": "var(--color-icon-order-status-rejected)",
        "icon-order-status-cancelled": "var(--color-icon-order-status-cancelled)",
        "icon-order-status-filled": "var(--color-icon-order-status-filled)",
        "icon-order-status-working": "var(--color-icon-order-status-working)",
        "icon-navigation-active": "var(--color-icon-navigation-active)",
        "icon-navigation-inactive": "var(--color-icon-navigation-inactive)",
        "icon-market-status-no-connection": "var(--color-icon-market-status-no-connection)",
        "icon-market-status-partial-connection": "var(--color-icon-market-status-partial-connection)",
        "icon-market-status-full-connection": "var(--color-icon-market-status-full-connection)",
        "icon-manage-opposite": "var(--color-icon-manage-opposite)",
        "icon-manage-similar": "var(--color-icon-manage-similar)",
        "icon-manage-replace": "var(--color-icon-manage-replace)",
        "icon-manage-view-complex": "var(--color-icon-manage-view-complex)",
        "icon-manage-cancel-complex": "var(--color-icon-manage-cancel-complex)",
        "icon-manage-cancel": "var(--color-icon-manage-cancel)",
        "icon-manage-analysis": "var(--color-icon-manage-analysis)",
        "icon-manage-bracket": "var(--color-icon-manage-bracket)",
        "icon-manage-view-details": "var(--color-icon-manage-view-details)",
        "icon-manage-quick-roll": "var(--color-icon-manage-quick-roll)",
        "icon-manage-view-working": "var(--color-icon-manage-view-working)",
        "icon-manage-percent-profit": "var(--color-icon-manage-percent-profit)",
        "icon-manage-close": "var(--color-icon-manage-close)",
        "icon-expand-arrow-inactive": "var(--color-icon-expand-arrow-inactive)",
        "icon-expand-arrow-active": "var(--color-icon-expand-arrow-active)",
        "icon-event-earnings": "var(--color-icon-event-earnings)",
        "icon-event-dividend": "var(--color-icon-event-dividend)",
        "icon-drag-handle-grip": "var(--color-icon-drag-handle-grip)",
        "icon-drag-handle-modal-handle": "var(--color-icon-drag-handle-modal-handle)",
        "icon-accounts-black": "var(--color-icon-accounts-black)",
        "icon-accounts-pink": "var(--color-icon-accounts-pink)",
        "icon-accounts-gold": "var(--color-icon-accounts-gold)",
        "icon-accounts-blue": "var(--color-icon-accounts-blue)",
        "icon-accounts-orange": "var(--color-icon-accounts-orange)",
        "icon-accounts-purple": "var(--color-icon-accounts-purple)",
        "icon-general-reminder": "var(--color-icon-general-reminder)",
        "icon-general-error": "var(--color-icon-general-error)",
        "icon-general-pending": "var(--color-icon-general-pending)",
        "icon-general-warning": "var(--color-icon-general-warning)",
        "icon-general-incorrect": "var(--color-icon-general-incorrect)",
        "icon-general-confirmation": "var(--color-icon-general-confirmation)",
        "icon-general-inactive": "var(--color-icon-general-inactive)",
        "icon-general-neutral-movement": "var(--color-icon-general-neutral-movement)",
        "icon-general-negative-movement": "var(--color-icon-general-negative-movement)",
        "icon-general-positive-movement": "var(--color-icon-general-positive-movement)",
        "icon-general-active-state": "var(--color-icon-general-active-state)",
        "icon-general-tertiary-action": "var(--color-icon-general-tertiary-action)",
        "icon-general-secondary-action": "var(--color-icon-general-secondary-action)",
        "icon-general-primary-action": "var(--color-icon-general-primary-action)",
        "icon-general-static-white-action": "var(--color-icon-general-static-white-action)",
        "icon-general-default-action": "var(--color-icon-general-default-action)",
    },
    borderColor: {
        "semantic-transparent": "var(--color-border-semantic-transparent)",
        "semantic-highlight": "var(--color-border-semantic-highlight)",
        "semantic-interaction-focused": "var(--color-border-semantic-interaction-focused)",
        "semantic-interaction-disabled": "var(--color-border-semantic-interaction-disabled)",
        "semantic-interaction-selected-accent": "var(--color-border-semantic-interaction-selected-accent)",
        "semantic-interaction-selected": "var(--color-border-semantic-interaction-selected)",
        "semantic-interaction-hovered-accent": "var(--color-border-semantic-interaction-hovered-accent)",
        "semantic-interaction-hovered": "var(--color-border-semantic-interaction-hovered)",
        "semantic-interaction": "var(--color-border-semantic-interaction)",
        "general-purple": "var(--color-border-general-purple)",
        "general-gold": "var(--color-border-general-gold)",
        "general-orange": "var(--color-border-general-orange)",
        "general-red": "var(--color-border-general-red)",
        "general-green": "var(--color-border-general-green)",
        "general-blue": "var(--color-border-general-blue)",
        "general-neutral-alpha-02": "var(--color-border-general-neutral-alpha-02)",
        "general-neutral-alpha-01": "var(--color-border-general-neutral-alpha-01)",
        "general-neutral-02": "var(--color-border-general-neutral-02)",
        "general-neutral-01": "var(--color-border-general-neutral-01)",
        "theoretical-chart-pl-line": "var(--color-border-theoretical-chart-pl-line)",
        "status-no-connection": "var(--color-border-status-no-connection)",
        "status-partial-connection": "var(--color-border-status-partial-connection)",
        "status-full-connection": "var(--color-border-status-full-connection)",
        "icon-liquidity-star-empty": "var(--color-border-icon-liquidity-star-empty)",
        "order-summary-pairs": "var(--color-border-order-summary-pairs)",
        "order-summary-one-cancel-order": "var(--color-border-order-summary-one-cancel-order)",
        "order-summary-stop-loss": "var(--color-border-order-summary-stop-loss)",
        "order-summary-close-at-profit": "var(--color-border-order-summary-close-at-profit)",
        "order-summary-order-entry": "var(--color-border-order-summary-order-entry)",
        "trading-objective-unselected": "var(--color-border-trading-objective-unselected)",
        "trading-objective-selected": "var(--color-border-trading-objective-selected)",
        "table-max-loss-highlight": "var(--color-border-table-max-loss-highlight)",
        "table-standard-deviation": "var(--color-border-table-standard-deviation)",
        "slider-sell": "var(--color-border-slider-sell)",
        "slider-buy": "var(--color-border-slider-buy)",
        "slider-slider-handle": "var(--color-border-slider-slider-handle)",
        "modal-modal-border": "var(--color-border-modal-modal-border)",
        "input-field-text-input-border": "var(--color-border-input-field-text-input-border)",
        "header-tab-underline-inactive": "var(--color-border-header-tab-underline-inactive)",
        "header-tab-underline-active": "var(--color-border-header-tab-underline-active)",
        "divider-vertical": "var(--color-border-divider-vertical)",
        "divider-horizontal-end": "var(--color-border-divider-horizontal-end)",
        "divider-horizontal": "var(--color-border-divider-horizontal)",
        "button-deselected": "var(--color-border-button-deselected)",
        "alert-pending": "var(--color-border-alert-pending)",
        "alert-confirmation": "var(--color-border-alert-confirmation)",
        "alert-information": "var(--color-border-alert-information)",
        "alert-reminder": "var(--color-border-alert-reminder)",
        "alert-order-canceled": "var(--color-border-alert-order-canceled)",
        "alert-order-working": "var(--color-border-alert-order-working)",
        "alert-info": "var(--color-border-alert-info)",
        "alert-error": "var(--color-border-alert-error)",
        "alert-success": "var(--color-border-alert-success)",
        "general-focused-state": "var(--color-border-general-focused-state)",
        "general-default": "var(--color-border-general-default)",
        "general-neutral-movement": "var(--color-border-general-neutral-movement)",
        "general-negative-movement": "var(--color-border-general-negative-movement)",
        "general-positive-movement": "var(--color-border-general-positive-movement)",
        "general-row-selection": "var(--color-border-general-row-selection)",
        "general-main-panel": "var(--color-border-general-main-panel)",
    },
    backgroundImage: {
        "button-order-status-working-hover": "var(--gradient-background-button-order-status-working-hover)",
        "button-upgrade-hover": "var(--gradient-background-button-upgrade-hover)",
        "button-default-hover": "var(--gradient-background-button-default-hover)",
        "button-asset-type-hover": "var(--gradient-background-button-asset-type-hover)",
        "button-review-and-send-hover": "var(--gradient-background-button-review-and-send-hover)",
        "button-continue-hover": "var(--gradient-background-button-continue-hover)",
        "button-put-hover": "var(--gradient-background-button-put-hover)",
        "button-sell-hover": "var(--gradient-background-button-sell-hover)",
        "button-cancel-hover": "var(--gradient-background-button-cancel-hover)",
        "button-call-hover": "var(--gradient-background-button-call-hover)",
        "button-buy-hover": "var(--gradient-background-button-buy-hover)",
        "button-confirmation-hover": "var(--gradient-background-button-confirmation-hover)",
    },
    nonDomainColors: {
        "other-ai-hover-end": "var(--color-other-ai-hover-end)",
        "other-ai-hover-start": "var(--color-other-ai-hover-start)",
        "other-ai-default-end": "var(--color-other-ai-default-end)",
        "other-ai-default-start": "var(--color-other-ai-default-start)",
        "other-crypto-surface-end-02": "var(--color-other-crypto-surface-end-02)",
        "other-crypto-surface-end-01": "var(--color-other-crypto-surface-end-01)",
        "other-crypto-surface-start": "var(--color-other-crypto-surface-start)",
        "other-native-key-secondary": "var(--color-other-native-key-secondary)",
        "other-native-key-primary": "var(--color-other-native-key-primary)",
        "other-native-keyboard": "var(--color-other-native-keyboard)",
        "other-key-pressed": "var(--color-other-key-pressed)",
        "other-key": "var(--color-other-key)",
        "other-elevation": "var(--color-other-elevation)",
        "other-overflow-surface-alt-end": "var(--color-other-overflow-surface-alt-end)",
        "other-overflow-surface-alt-start": "var(--color-other-overflow-surface-alt-start)",
        "other-overflow-surface-end": "var(--color-other-overflow-surface-end)",
        "other-overflow-surface-start": "var(--color-other-overflow-surface-start)",
        "other-overflow-modal-end": "var(--color-other-overflow-modal-end)",
        "other-overflow-modal-start": "var(--color-other-overflow-modal-start)",
        "other-overflow-end": "var(--color-other-overflow-end)",
        "other-overflow-start": "var(--color-other-overflow-start)",
        "brand-zerohash-bg-overlay": "var(--color-brand-zerohash-bg-overlay)",
        "brand-zerohash-bg-modal-header-end": "var(--color-brand-zerohash-bg-modal-header-end)",
        "brand-zerohash-bg-modal-header-start": "var(--color-brand-zerohash-bg-modal-header-start)",
        "brand-zerohash-bg-surface-end": "var(--color-brand-zerohash-bg-surface-end)",
        "brand-zerohash-bg-surface-start": "var(--color-brand-zerohash-bg-surface-start)",
        "brand-zerohash-bg-modal-body-end": "var(--color-brand-zerohash-bg-modal-body-end)",
        "brand-zerohash-bg-modal-body-start": "var(--color-brand-zerohash-bg-modal-body-start)",
        "brand-zerohash-bg-modal-card": "var(--color-brand-zerohash-bg-modal-card)",
        "brand-zerohash-bg-chart": "var(--color-brand-zerohash-bg-chart)",
        "brand-zerohash-bg-pink-alpha": "var(--color-brand-zerohash-bg-pink-alpha)",
        "brand-zerohash-bg-pink": "var(--color-brand-zerohash-bg-pink)",
        "brand-zerohash-bg-green-alpha": "var(--color-brand-zerohash-bg-green-alpha)",
        "brand-zerohash-bg-green": "var(--color-brand-zerohash-bg-green)",
        "brand-zerohash-bg-purple-alpha": "var(--color-brand-zerohash-bg-purple-alpha)",
        "brand-zerohash-bg-purple-02": "var(--color-brand-zerohash-bg-purple-02)",
        "brand-zerohash-bg-purple-01": "var(--color-brand-zerohash-bg-purple-01)",
        "brand-zerohash-button-purple-hover": "var(--color-brand-zerohash-button-purple-hover)",
        "brand-zerohash-button-purple": "var(--color-brand-zerohash-button-purple)",
        "brand-zerohash-button-pink-hover": "var(--color-brand-zerohash-button-pink-hover)",
        "brand-zerohash-button-pink": "var(--color-brand-zerohash-button-pink)",
        "brand-zerohash-button-green-hover": "var(--color-brand-zerohash-button-green-hover)",
        "brand-zerohash-button-green": "var(--color-brand-zerohash-button-green)",
        "brand-zerohash-border-purple-alpha": "var(--color-brand-zerohash-border-purple-alpha)",
        "brand-zerohash-border-purple-subtle": "var(--color-brand-zerohash-border-purple-subtle)",
        "brand-zerohash-border-purple": "var(--color-brand-zerohash-border-purple)",
        "brand-zerohash-border-pink": "var(--color-brand-zerohash-border-pink)",
        "brand-zerohash-border-green": "var(--color-brand-zerohash-border-green)",
        "brand-zerohash-text-icon-purple": "var(--color-brand-zerohash-text-icon-purple)",
        "brand-zerohash-text-icon-pink-inverted": "var(--color-brand-zerohash-text-icon-pink-inverted)",
        "brand-zerohash-text-icon-pink": "var(--color-brand-zerohash-text-icon-pink)",
        "brand-zerohash-text-icon-green-inverted": "var(--color-brand-zerohash-text-icon-green-inverted)",
        "brand-zerohash-text-icon-green": "var(--color-brand-zerohash-text-icon-green)",
        "brand-zerohash-logo-green": "var(--color-brand-zerohash-logo-green)",
        "brand-zerohash-logo-default": "var(--color-brand-zerohash-logo-default)",
        "brand-zerohash-logo": "var(--color-brand-zerohash-logo)",
        "brand-wise-alpha": "var(--color-brand-wise-alpha)",
        "brand-wise-text-inverted": "var(--color-brand-wise-text-inverted)",
        "brand-wise-text": "var(--color-brand-wise-text)",
        "brand-wise-accent-hover": "var(--color-brand-wise-accent-hover)",
        "brand-wise-accent": "var(--color-brand-wise-accent)",
        "brand-tasty-teal": "var(--color-brand-tasty-teal)",
        "brand-tasty-chartreuse": "var(--color-brand-tasty-chartreuse)",
        "brand-tasty-yellow": "var(--color-brand-tasty-yellow)",
        "brand-tasty-wine": "var(--color-brand-tasty-wine)",
        "brand-tasty-apple": "var(--color-brand-tasty-apple)",
        "brand-tasty-cherry": "var(--color-brand-tasty-cherry)",
        "brand-tasty-charcoal": "var(--color-brand-tasty-charcoal)",
        "brand-tasty-gray": "var(--color-brand-tasty-gray)",
        "brand-tasty-black": "var(--color-brand-tasty-black)",
        "brand-tasty-white": "var(--color-brand-tasty-white)",
        "chart-auxiliary-color-04-subtle": "var(--color-chart-auxiliary-color-04-subtle)",
        "chart-auxiliary-color-04": "var(--color-chart-auxiliary-color-04)",
        "chart-auxiliary-color-03-subtle": "var(--color-chart-auxiliary-color-03-subtle)",
        "chart-auxiliary-color-03": "var(--color-chart-auxiliary-color-03)",
        "chart-auxiliary-color-02-subtle": "var(--color-chart-auxiliary-color-02-subtle)",
        "chart-auxiliary-color-02": "var(--color-chart-auxiliary-color-02)",
        "chart-auxiliary-color-01-subtle": "var(--color-chart-auxiliary-color-01-subtle)",
        "chart-auxiliary-color-01": "var(--color-chart-auxiliary-color-01)",
        "chart-functional-negative-area-end": "var(--color-chart-functional-negative-area-end)",
        "chart-functional-negative-area-start": "var(--color-chart-functional-negative-area-start)",
        "chart-functional-negative-area": "var(--color-chart-functional-negative-area)",
        "chart-functional-negative-subtle": "var(--color-chart-functional-negative-subtle)",
        "chart-functional-negative": "var(--color-chart-functional-negative)",
        "chart-functional-positive-area-end": "var(--color-chart-functional-positive-area-end)",
        "chart-functional-positive-area-start": "var(--color-chart-functional-positive-area-start)",
        "chart-functional-positive-area": "var(--color-chart-functional-positive-area)",
        "chart-functional-positive-subtle": "var(--color-chart-functional-positive-subtle)",
        "chart-functional-positive": "var(--color-chart-functional-positive)",
        "chart-functional-neutral-area-end": "var(--color-chart-functional-neutral-area-end)",
        "chart-functional-neutral-area-start": "var(--color-chart-functional-neutral-area-start)",
        "chart-functional-neutral-area": "var(--color-chart-functional-neutral-area)",
        "chart-functional-neutral-subtle": "var(--color-chart-functional-neutral-subtle)",
        "chart-functional-neutral": "var(--color-chart-functional-neutral)",
        "zero-hash-brand-cam-field-disabled": "var(--color-zero-hash-brand-cam-field-disabled)",
        "zero-hash-brand-cam-field-secondary": "var(--color-zero-hash-brand-cam-field-secondary)",
        "zero-hash-brand-cam-field-primary": "var(--color-zero-hash-brand-cam-field-primary)",
        "zero-hash-brand-cam-alert-purple": "var(--color-zero-hash-brand-cam-alert-purple)",
        "zero-hash-brand-cam-alert-pink": "var(--color-zero-hash-brand-cam-alert-pink)",
        "zero-hash-brand-modal-overlay": "var(--color-zero-hash-brand-modal-overlay)",
        "zero-hash-brand-modal-bg-secondary": "var(--color-zero-hash-brand-modal-bg-secondary)",
        "zero-hash-brand-chart-bg": "var(--color-zero-hash-brand-chart-bg)",
        "zero-hash-brand-bg-purple-2": "var(--color-zero-hash-brand-bg-purple-2)",
        "zero-hash-brand-bg-purple-1": "var(--color-zero-hash-brand-bg-purple-1)",
        "zero-hash-brand-button-purple": "var(--color-zero-hash-brand-button-purple)",
        "zero-hash-brand-button-pink": "var(--color-zero-hash-brand-button-pink)",
        "zero-hash-brand-button-green": "var(--color-zero-hash-brand-button-green)",
        "zero-hash-brand-border-purple-25": "var(--color-zero-hash-brand-border-purple-25)",
        "zero-hash-brand-border-purple-50": "var(--color-zero-hash-brand-border-purple-50)",
        "zero-hash-brand-border-purple": "var(--color-zero-hash-brand-border-purple)",
        "zero-hash-brand-border-pink": "var(--color-zero-hash-brand-border-pink)",
        "zero-hash-brand-border-green": "var(--color-zero-hash-brand-border-green)",
        "zero-hash-brand-text-purple": "var(--color-zero-hash-brand-text-purple)",
        "zero-hash-brand-text-black-to-white": "var(--color-zero-hash-brand-text-black-to-white)",
        "zero-hash-brand-text-pink": "var(--color-zero-hash-brand-text-pink)",
        "zero-hash-brand-text-green": "var(--color-zero-hash-brand-text-green)",
        "zero-hash-brand-icon-purple": "var(--color-zero-hash-brand-icon-purple)",
        "zero-hash-brand-icon-pink": "var(--color-zero-hash-brand-icon-pink)",
        "zero-hash-brand-icon-green": "var(--color-zero-hash-brand-icon-green)",
        "zero-hash-brand-logo-green": "var(--color-zero-hash-brand-logo-green)",
        "zero-hash-brand-logo-default": "var(--color-zero-hash-brand-logo-default)",
        "brand-solid-teal": "var(--color-brand-solid-teal)",
        "brand-solid-chartreuse": "var(--color-brand-solid-chartreuse)",
        "brand-solid-yellow": "var(--color-brand-solid-yellow)",
        "brand-solid-wine": "var(--color-brand-solid-wine)",
        "brand-solid-apple": "var(--color-brand-solid-apple)",
        "brand-solid-cherry": "var(--color-brand-solid-cherry)",
        "brand-solid-black": "var(--color-brand-solid-black)",
        "brand-solid-charcoal": "var(--color-brand-solid-charcoal)",
        "brand-solid-gray": "var(--color-brand-solid-gray)",
        "brand-solid-white": "var(--color-brand-solid-white)",
        "chart-area-negative": "var(--color-chart-area-negative)",
        "chart-area-positive": "var(--color-chart-area-positive)",
        "chart-area-neutral": "var(--color-chart-area-neutral)",
        "chart-order-indicator-working": "var(--color-chart-order-indicator-working)",
        "chart-order-indicator-filled": "var(--color-chart-order-indicator-filled)",
        "chart-financials-liabilities": "var(--color-chart-financials-liabilities)",
        "chart-financials-assets": "var(--color-chart-financials-assets)",
        "chart-financials-net-income": "var(--color-chart-financials-net-income)",
        "chart-financials-revenue": "var(--color-chart-financials-revenue)",
        "chart-grid-transparent": "var(--color-chart-grid-transparent)",
        "chart-grid-horizontal": "var(--color-chart-grid-horizontal)",
        "chart-grid-vertical": "var(--color-chart-grid-vertical)",
        "chart-candle-negative": "var(--color-chart-candle-negative)",
        "chart-candle-positive": "var(--color-chart-candle-positive)",
        "chart-analyst-rating-strong-sell": "var(--color-chart-analyst-rating-strong-sell)",
        "chart-analyst-rating-sell": "var(--color-chart-analyst-rating-sell)",
        "chart-analyst-rating-hold": "var(--color-chart-analyst-rating-hold)",
        "chart-analyst-rating-buy": "var(--color-chart-analyst-rating-buy)",
        "chart-analyst-rating-strong-buy": "var(--color-chart-analyst-rating-strong-buy)",
        "solid-neutral-100": "var(--color-solid-neutral-100)",
        "solid-neutral-200": "var(--color-solid-neutral-200)",
        "solid-neutral-250": "var(--color-solid-neutral-250)",
        "solid-neutral-300": "var(--color-solid-neutral-300)",
        "solid-neutral-350": "var(--color-solid-neutral-350)",
        "solid-neutral-400": "var(--color-solid-neutral-400)",
        "solid-neutral-450": "var(--color-solid-neutral-450)",
        "solid-neutral-550": "var(--color-solid-neutral-550)",
        "solid-neutral-600": "var(--color-solid-neutral-600)",
        "solid-neutral-650": "var(--color-solid-neutral-650)",
        "solid-neutral-700": "var(--color-solid-neutral-700)",
        "solid-neutral-750": "var(--color-solid-neutral-750)",
        "solid-neutral-800": "var(--color-solid-neutral-800)",
        "solid-neutral-900": "var(--color-solid-neutral-900)",
        "solid-neutral-950": "var(--color-solid-neutral-950)",
        "solid-neutral-1000": "var(--color-solid-neutral-1000)",
        "solid-neutral-000": "var(--color-solid-neutral-000)",
        "solid-neutral-050": "var(--color-solid-neutral-050)",
        "solid-red-100": "var(--color-solid-red-100)",
        "solid-red-200": "var(--color-solid-red-200)",
        "solid-red-300": "var(--color-solid-red-300)",
        "solid-red-400": "var(--color-solid-red-400)",
        "solid-red-450": "var(--color-solid-red-450)",
        "solid-red-550": "var(--color-solid-red-550)",
        "solid-red-600": "var(--color-solid-red-600)",
        "solid-red-700": "var(--color-solid-red-700)",
        "solid-red-800": "var(--color-solid-red-800)",
        "solid-red-900": "var(--color-solid-red-900)",
        "solid-red-950": "var(--color-solid-red-950)",
        "solid-red-050": "var(--color-solid-red-050)",
        "solid-orange-100": "var(--color-solid-orange-100)",
        "solid-orange-200": "var(--color-solid-orange-200)",
        "solid-orange-300": "var(--color-solid-orange-300)",
        "solid-orange-400": "var(--color-solid-orange-400)",
        "solid-orange-450": "var(--color-solid-orange-450)",
        "solid-orange-550": "var(--color-solid-orange-550)",
        "solid-orange-600": "var(--color-solid-orange-600)",
        "solid-orange-700": "var(--color-solid-orange-700)",
        "solid-orange-800": "var(--color-solid-orange-800)",
        "solid-orange-900": "var(--color-solid-orange-900)",
        "solid-orange-950": "var(--color-solid-orange-950)",
        "solid-orange-050": "var(--color-solid-orange-050)",
        "solid-gold-100": "var(--color-solid-gold-100)",
        "solid-gold-200": "var(--color-solid-gold-200)",
        "solid-gold-300": "var(--color-solid-gold-300)",
        "solid-gold-400": "var(--color-solid-gold-400)",
        "solid-gold-450": "var(--color-solid-gold-450)",
        "solid-gold-550": "var(--color-solid-gold-550)",
        "solid-gold-600": "var(--color-solid-gold-600)",
        "solid-gold-700": "var(--color-solid-gold-700)",
        "solid-gold-800": "var(--color-solid-gold-800)",
        "solid-gold-900": "var(--color-solid-gold-900)",
        "solid-gold-950": "var(--color-solid-gold-950)",
        "solid-gold-050": "var(--color-solid-gold-050)",
        "solid-green-100": "var(--color-solid-green-100)",
        "solid-green-200": "var(--color-solid-green-200)",
        "solid-green-300": "var(--color-solid-green-300)",
        "solid-green-400": "var(--color-solid-green-400)",
        "solid-green-450": "var(--color-solid-green-450)",
        "solid-green-550": "var(--color-solid-green-550)",
        "solid-green-600": "var(--color-solid-green-600)",
        "solid-green-700": "var(--color-solid-green-700)",
        "solid-green-800": "var(--color-solid-green-800)",
        "solid-green-900": "var(--color-solid-green-900)",
        "solid-green-950": "var(--color-solid-green-950)",
        "solid-green-050": "var(--color-solid-green-050)",
        "solid-blue-100": "var(--color-solid-blue-100)",
        "solid-blue-200": "var(--color-solid-blue-200)",
        "solid-blue-300": "var(--color-solid-blue-300)",
        "solid-blue-400": "var(--color-solid-blue-400)",
        "solid-blue-450": "var(--color-solid-blue-450)",
        "solid-blue-550": "var(--color-solid-blue-550)",
        "solid-blue-600": "var(--color-solid-blue-600)",
        "solid-blue-700": "var(--color-solid-blue-700)",
        "solid-blue-800": "var(--color-solid-blue-800)",
        "solid-blue-900": "var(--color-solid-blue-900)",
        "solid-blue-950": "var(--color-solid-blue-950)",
        "solid-blue-050": "var(--color-solid-blue-050)",
        "solid-purple-100": "var(--color-solid-purple-100)",
        "solid-purple-200": "var(--color-solid-purple-200)",
        "solid-purple-300": "var(--color-solid-purple-300)",
        "solid-purple-400": "var(--color-solid-purple-400)",
        "solid-purple-450": "var(--color-solid-purple-450)",
        "solid-purple-550": "var(--color-solid-purple-550)",
        "solid-purple-600": "var(--color-solid-purple-600)",
        "solid-purple-700": "var(--color-solid-purple-700)",
        "solid-purple-800": "var(--color-solid-purple-800)",
        "solid-purple-900": "var(--color-solid-purple-900)",
        "solid-purple-950": "var(--color-solid-purple-950)",
        "solid-purple-050": "var(--color-solid-purple-050)",
        "solid-pink-100": "var(--color-solid-pink-100)",
        "solid-pink-200": "var(--color-solid-pink-200)",
        "solid-pink-300": "var(--color-solid-pink-300)",
        "solid-pink-400": "var(--color-solid-pink-400)",
        "solid-pink-450": "var(--color-solid-pink-450)",
        "solid-pink-550": "var(--color-solid-pink-550)",
        "solid-pink-600": "var(--color-solid-pink-600)",
        "solid-pink-700": "var(--color-solid-pink-700)",
        "solid-pink-800": "var(--color-solid-pink-800)",
        "solid-pink-900": "var(--color-solid-pink-900)",
        "solid-pink-950": "var(--color-solid-pink-950)",
        "solid-pink-050": "var(--color-solid-pink-050)",
        "solid-iris-100": "var(--color-solid-iris-100)",
        "solid-iris-200": "var(--color-solid-iris-200)",
        "solid-iris-300": "var(--color-solid-iris-300)",
        "solid-iris-400": "var(--color-solid-iris-400)",
        "solid-iris-450": "var(--color-solid-iris-450)",
        "solid-iris-550": "var(--color-solid-iris-550)",
        "solid-iris-600": "var(--color-solid-iris-600)",
        "solid-iris-700": "var(--color-solid-iris-700)",
        "solid-iris-800": "var(--color-solid-iris-800)",
        "solid-iris-900": "var(--color-solid-iris-900)",
        "solid-iris-950": "var(--color-solid-iris-950)",
        "solid-iris-050": "var(--color-solid-iris-050)",
        "solid-slate-100": "var(--color-solid-slate-100)",
        "solid-slate-200": "var(--color-solid-slate-200)",
        "solid-slate-300": "var(--color-solid-slate-300)",
        "solid-slate-400": "var(--color-solid-slate-400)",
        "solid-slate-450": "var(--color-solid-slate-450)",
        "solid-slate-550": "var(--color-solid-slate-550)",
        "solid-slate-600": "var(--color-solid-slate-600)",
        "solid-slate-700": "var(--color-solid-slate-700)",
        "solid-slate-800": "var(--color-solid-slate-800)",
        "solid-slate-900": "var(--color-solid-slate-900)",
        "solid-slate-950": "var(--color-solid-slate-950)",
        "solid-slate-050": "var(--color-solid-slate-050)",
        "solid-tan-100": "var(--color-solid-tan-100)",
        "solid-tan-200": "var(--color-solid-tan-200)",
        "solid-tan-300": "var(--color-solid-tan-300)",
        "solid-tan-400": "var(--color-solid-tan-400)",
        "solid-tan-450": "var(--color-solid-tan-450)",
        "solid-tan-550": "var(--color-solid-tan-550)",
        "solid-tan-600": "var(--color-solid-tan-600)",
        "solid-tan-700": "var(--color-solid-tan-700)",
        "solid-tan-800": "var(--color-solid-tan-800)",
        "solid-tan-900": "var(--color-solid-tan-900)",
        "solid-tan-950": "var(--color-solid-tan-950)",
        "solid-tan-050": "var(--color-solid-tan-050)",
        "solid-clay-100": "var(--color-solid-clay-100)",
        "solid-clay-200": "var(--color-solid-clay-200)",
        "solid-clay-300": "var(--color-solid-clay-300)",
        "solid-clay-400": "var(--color-solid-clay-400)",
        "solid-clay-450": "var(--color-solid-clay-450)",
        "solid-clay-550": "var(--color-solid-clay-550)",
        "solid-clay-600": "var(--color-solid-clay-600)",
        "solid-clay-700": "var(--color-solid-clay-700)",
        "solid-clay-800": "var(--color-solid-clay-800)",
        "solid-clay-900": "var(--color-solid-clay-900)",
        "solid-clay-950": "var(--color-solid-clay-950)",
        "solid-clay-050": "var(--color-solid-clay-050)",
        "solid-tasty-cherry": "var(--color-solid-tasty-cherry)",
        "solid-tasty-white": "var(--color-solid-tasty-white)",
        "solid-tasty-black": "var(--color-solid-tasty-black)",
        "solid-tasty-gray": "var(--color-solid-tasty-gray)",
        "solid-tasty-charcoal": "var(--color-solid-tasty-charcoal)",
        "solid-tasty-apple": "var(--color-solid-tasty-apple)",
        "solid-tasty-wine": "var(--color-solid-tasty-wine)",
        "solid-tasty-yellow": "var(--color-solid-tasty-yellow)",
        "solid-tasty-chartreuse": "var(--color-solid-tasty-chartreuse)",
        "solid-tasty-teal": "var(--color-solid-tasty-teal)",
        "solid-zerohash-mint": "var(--color-solid-zerohash-mint)",
        "solid-zerohash-black": "var(--color-solid-zerohash-black)",
        "solid-wise-green-01": "var(--color-solid-wise-green-01)",
        "solid-wise-green-02": "var(--color-solid-wise-green-02)",
        "solid-wise-forest-01": "var(--color-solid-wise-forest-01)",
        "solid-wise-forest-02": "var(--color-solid-wise-forest-02)",
        "solid-wise-alpha-01": "var(--color-solid-wise-alpha-01)",
        "solid-wise-alpha-02": "var(--color-solid-wise-alpha-02)",
        "alpha-neutral-100": "var(--color-alpha-neutral-100)",
        "alpha-neutral-200": "var(--color-alpha-neutral-200)",
        "alpha-neutral-250": "var(--color-alpha-neutral-250)",
        "alpha-neutral-300": "var(--color-alpha-neutral-300)",
        "alpha-neutral-350": "var(--color-alpha-neutral-350)",
        "alpha-neutral-400": "var(--color-alpha-neutral-400)",
        "alpha-neutral-450": "var(--color-alpha-neutral-450)",
        "alpha-neutral-550": "var(--color-alpha-neutral-550)",
        "alpha-neutral-600": "var(--color-alpha-neutral-600)",
        "alpha-neutral-650": "var(--color-alpha-neutral-650)",
        "alpha-neutral-700": "var(--color-alpha-neutral-700)",
        "alpha-neutral-750": "var(--color-alpha-neutral-750)",
        "alpha-neutral-800": "var(--color-alpha-neutral-800)",
        "alpha-neutral-900": "var(--color-alpha-neutral-900)",
        "alpha-neutral-950": "var(--color-alpha-neutral-950)",
        "alpha-neutral-1000": "var(--color-alpha-neutral-1000)",
        "alpha-neutral-000": "var(--color-alpha-neutral-000)",
        "alpha-neutral-050": "var(--color-alpha-neutral-050)",
        "alpha-neutral-000-alt": "var(--color-alpha-neutral-000-alt)",
        "alpha-neutral-1000-alt": "var(--color-alpha-neutral-1000-alt)",
        "alpha-red-100": "var(--color-alpha-red-100)",
        "alpha-red-200": "var(--color-alpha-red-200)",
        "alpha-red-800": "var(--color-alpha-red-800)",
        "alpha-red-900": "var(--color-alpha-red-900)",
        "alpha-red-950": "var(--color-alpha-red-950)",
        "alpha-red-1000": "var(--color-alpha-red-1000)",
        "alpha-red-000": "var(--color-alpha-red-000)",
        "alpha-red-050": "var(--color-alpha-red-050)",
        "alpha-orange-100": "var(--color-alpha-orange-100)",
        "alpha-orange-200": "var(--color-alpha-orange-200)",
        "alpha-orange-800": "var(--color-alpha-orange-800)",
        "alpha-orange-900": "var(--color-alpha-orange-900)",
        "alpha-orange-950": "var(--color-alpha-orange-950)",
        "alpha-orange-1000": "var(--color-alpha-orange-1000)",
        "alpha-orange-000": "var(--color-alpha-orange-000)",
        "alpha-orange-050": "var(--color-alpha-orange-050)",
        "alpha-gold-100": "var(--color-alpha-gold-100)",
        "alpha-gold-200": "var(--color-alpha-gold-200)",
        "alpha-gold-800": "var(--color-alpha-gold-800)",
        "alpha-gold-900": "var(--color-alpha-gold-900)",
        "alpha-gold-950": "var(--color-alpha-gold-950)",
        "alpha-gold-1000": "var(--color-alpha-gold-1000)",
        "alpha-gold-000": "var(--color-alpha-gold-000)",
        "alpha-gold-050": "var(--color-alpha-gold-050)",
        "alpha-green-100": "var(--color-alpha-green-100)",
        "alpha-green-200": "var(--color-alpha-green-200)",
        "alpha-green-800": "var(--color-alpha-green-800)",
        "alpha-green-900": "var(--color-alpha-green-900)",
        "alpha-green-950": "var(--color-alpha-green-950)",
        "alpha-green-1000": "var(--color-alpha-green-1000)",
        "alpha-green-000": "var(--color-alpha-green-000)",
        "alpha-green-050": "var(--color-alpha-green-050)",
        "alpha-blue-100": "var(--color-alpha-blue-100)",
        "alpha-blue-200": "var(--color-alpha-blue-200)",
        "alpha-blue-800": "var(--color-alpha-blue-800)",
        "alpha-blue-900": "var(--color-alpha-blue-900)",
        "alpha-blue-950": "var(--color-alpha-blue-950)",
        "alpha-blue-1000": "var(--color-alpha-blue-1000)",
        "alpha-blue-000": "var(--color-alpha-blue-000)",
        "alpha-blue-050": "var(--color-alpha-blue-050)",
        "alpha-purple-100": "var(--color-alpha-purple-100)",
        "alpha-purple-200": "var(--color-alpha-purple-200)",
        "alpha-purple-800": "var(--color-alpha-purple-800)",
        "alpha-purple-900": "var(--color-alpha-purple-900)",
        "alpha-purple-950": "var(--color-alpha-purple-950)",
        "alpha-purple-1000": "var(--color-alpha-purple-1000)",
        "alpha-purple-000": "var(--color-alpha-purple-000)",
        "alpha-purple-050": "var(--color-alpha-purple-050)",
        "alpha-pink-100": "var(--color-alpha-pink-100)",
        "alpha-pink-200": "var(--color-alpha-pink-200)",
        "alpha-pink-800": "var(--color-alpha-pink-800)",
        "alpha-pink-900": "var(--color-alpha-pink-900)",
        "alpha-pink-950": "var(--color-alpha-pink-950)",
        "alpha-pink-1000": "var(--color-alpha-pink-1000)",
        "alpha-pink-000": "var(--color-alpha-pink-000)",
        "alpha-pink-050": "var(--color-alpha-pink-050)",
        "alpha-iris-100": "var(--color-alpha-iris-100)",
        "alpha-iris-200": "var(--color-alpha-iris-200)",
        "alpha-iris-800": "var(--color-alpha-iris-800)",
        "alpha-iris-900": "var(--color-alpha-iris-900)",
        "alpha-iris-950": "var(--color-alpha-iris-950)",
        "alpha-iris-1000": "var(--color-alpha-iris-1000)",
        "alpha-iris-000": "var(--color-alpha-iris-000)",
        "alpha-iris-050": "var(--color-alpha-iris-050)",
        "alpha-slate-100": "var(--color-alpha-slate-100)",
        "alpha-slate-200": "var(--color-alpha-slate-200)",
        "alpha-slate-800": "var(--color-alpha-slate-800)",
        "alpha-slate-900": "var(--color-alpha-slate-900)",
        "alpha-slate-950": "var(--color-alpha-slate-950)",
        "alpha-slate-1000": "var(--color-alpha-slate-1000)",
        "alpha-slate-000": "var(--color-alpha-slate-000)",
        "alpha-slate-050": "var(--color-alpha-slate-050)",
        "alpha-tan-100": "var(--color-alpha-tan-100)",
        "alpha-tan-200": "var(--color-alpha-tan-200)",
        "alpha-tan-800": "var(--color-alpha-tan-800)",
        "alpha-tan-900": "var(--color-alpha-tan-900)",
        "alpha-tan-950": "var(--color-alpha-tan-950)",
        "alpha-tan-1000": "var(--color-alpha-tan-1000)",
        "alpha-tan-000": "var(--color-alpha-tan-000)",
        "alpha-tan-050": "var(--color-alpha-tan-050)",
        "alpha-clay-100": "var(--color-alpha-clay-100)",
        "alpha-clay-200": "var(--color-alpha-clay-200)",
        "alpha-clay-800": "var(--color-alpha-clay-800)",
        "alpha-clay-900": "var(--color-alpha-clay-900)",
        "alpha-clay-950": "var(--color-alpha-clay-950)",
        "alpha-clay-1000": "var(--color-alpha-clay-1000)",
        "alpha-clay-000": "var(--color-alpha-clay-000)",
        "alpha-clay-050": "var(--color-alpha-clay-050)",
        "alpha-functional-blanket-01": "var(--color-alpha-functional-blanket-01)",
        "alpha-functional-blanket-02": "var(--color-alpha-functional-blanket-02)",
        "alpha-functional-blanket-03": "var(--color-alpha-functional-blanket-03)",
        "alpha-functional-glass-surface-dark": "var(--color-alpha-functional-glass-surface-dark)",
        "alpha-functional-glass-surface-light": "var(--color-alpha-functional-glass-surface-light)",
        "alpha-functional-glass-body-dark": "var(--color-alpha-functional-glass-body-dark)",
        "alpha-functional-glass-body-light": "var(--color-alpha-functional-glass-body-light)",
        "zerohash-brand-white": "var(--color-zerohash-brand-white)",
        "zerohash-brand-black": "var(--color-zerohash-brand-black)",
        "zerohash-brand-green": "var(--color-zerohash-brand-green)",
        "zerohash-green-100": "var(--color-zerohash-green-100)",
        "zerohash-green-200": "var(--color-zerohash-green-200)",
        "zerohash-green-300": "var(--color-zerohash-green-300)",
        "zerohash-green-400": "var(--color-zerohash-green-400)",
        "zerohash-green-450": "var(--color-zerohash-green-450)",
        "zerohash-green-550": "var(--color-zerohash-green-550)",
        "zerohash-green-600": "var(--color-zerohash-green-600)",
        "zerohash-green-700": "var(--color-zerohash-green-700)",
        "zerohash-green-800": "var(--color-zerohash-green-800)",
        "zerohash-green-900": "var(--color-zerohash-green-900)",
        "zerohash-green-950": "var(--color-zerohash-green-950)",
        "zerohash-green-050": "var(--color-zerohash-green-050)",
        "zerohash-green-alpha-100": "var(--color-zerohash-green-alpha-100)",
        "zerohash-green-alpha-200": "var(--color-zerohash-green-alpha-200)",
        "zerohash-green-alpha-800": "var(--color-zerohash-green-alpha-800)",
        "zerohash-green-alpha-900": "var(--color-zerohash-green-alpha-900)",
        "zerohash-green-alpha-950": "var(--color-zerohash-green-alpha-950)",
        "zerohash-green-alpha-1000": "var(--color-zerohash-green-alpha-1000)",
        "zerohash-green-alpha-000": "var(--color-zerohash-green-alpha-000)",
        "zerohash-green-alpha-050": "var(--color-zerohash-green-alpha-050)",
        "zerohash-pink-100": "var(--color-zerohash-pink-100)",
        "zerohash-pink-200": "var(--color-zerohash-pink-200)",
        "zerohash-pink-300": "var(--color-zerohash-pink-300)",
        "zerohash-pink-400": "var(--color-zerohash-pink-400)",
        "zerohash-pink-450": "var(--color-zerohash-pink-450)",
        "zerohash-pink-550": "var(--color-zerohash-pink-550)",
        "zerohash-pink-600": "var(--color-zerohash-pink-600)",
        "zerohash-pink-700": "var(--color-zerohash-pink-700)",
        "zerohash-pink-800": "var(--color-zerohash-pink-800)",
        "zerohash-pink-900": "var(--color-zerohash-pink-900)",
        "zerohash-pink-950": "var(--color-zerohash-pink-950)",
        "zerohash-pink-050": "var(--color-zerohash-pink-050)",
        "zerohash-pink-alpha-100": "var(--color-zerohash-pink-alpha-100)",
        "zerohash-pink-alpha-200": "var(--color-zerohash-pink-alpha-200)",
        "zerohash-pink-alpha-800": "var(--color-zerohash-pink-alpha-800)",
        "zerohash-pink-alpha-900": "var(--color-zerohash-pink-alpha-900)",
        "zerohash-pink-alpha-950": "var(--color-zerohash-pink-alpha-950)",
        "zerohash-pink-alpha-1000": "var(--color-zerohash-pink-alpha-1000)",
        "zerohash-pink-alpha-000": "var(--color-zerohash-pink-alpha-000)",
        "zerohash-pink-alpha-050": "var(--color-zerohash-pink-alpha-050)",
        "zerohash-purple-100": "var(--color-zerohash-purple-100)",
        "zerohash-purple-200": "var(--color-zerohash-purple-200)",
        "zerohash-purple-300": "var(--color-zerohash-purple-300)",
        "zerohash-purple-400": "var(--color-zerohash-purple-400)",
        "zerohash-purple-450": "var(--color-zerohash-purple-450)",
        "zerohash-purple-550": "var(--color-zerohash-purple-550)",
        "zerohash-purple-600": "var(--color-zerohash-purple-600)",
        "zerohash-purple-700": "var(--color-zerohash-purple-700)",
        "zerohash-purple-800": "var(--color-zerohash-purple-800)",
        "zerohash-purple-900": "var(--color-zerohash-purple-900)",
        "zerohash-purple-950": "var(--color-zerohash-purple-950)",
        "zerohash-purple-1000": "var(--color-zerohash-purple-1000)",
        "zerohash-purple-050": "var(--color-zerohash-purple-050)",
        "zerohash-purple-alpha-100": "var(--color-zerohash-purple-alpha-100)",
        "zerohash-purple-alpha-200": "var(--color-zerohash-purple-alpha-200)",
        "zerohash-purple-alpha-800": "var(--color-zerohash-purple-alpha-800)",
        "zerohash-purple-alpha-900": "var(--color-zerohash-purple-alpha-900)",
        "zerohash-purple-alpha-950": "var(--color-zerohash-purple-alpha-950)",
        "zerohash-purple-alpha-1000": "var(--color-zerohash-purple-alpha-1000)",
        "zerohash-purple-alpha-000": "var(--color-zerohash-purple-alpha-000)",
        "zerohash-purple-alpha-050": "var(--color-zerohash-purple-alpha-050)",
        "zerohash-purple-alpha-blanket": "var(--color-zerohash-purple-alpha-blanket)",
        "zero-hash-brand-button-purple-hover": "var(--gradient-zero-hash-brand-button-purple-hover)",
        "zero-hash-brand-button-pink-hover": "var(--gradient-zero-hash-brand-button-pink-hover)",
        "zero-hash-brand-button-green-hover": "var(--gradient-zero-hash-brand-button-green-hover)",
        "chart-negative-area-bottom": "var(--gradient-chart-negative-area-bottom)",
        "chart-negative-area-top": "var(--gradient-chart-negative-area-top)",
        "chart-positive-area-bottom": "var(--gradient-chart-positive-area-bottom)",
        "chart-positive-area-top": "var(--gradient-chart-positive-area-top)",
        "chart-neutral-area-bottom": "var(--gradient-chart-neutral-area-bottom)",
        "chart-neutral-area-top": "var(--gradient-chart-neutral-area-top)",
        "overflow-on-surface-alt-right": "var(--gradient-overflow-on-surface-alt-right)",
        "overflow-on-surface-alt-left": "var(--gradient-overflow-on-surface-alt-left)",
        "overflow-on-surface-alt-bottom": "var(--gradient-overflow-on-surface-alt-bottom)",
        "overflow-on-surface-alt-top": "var(--gradient-overflow-on-surface-alt-top)",
        "overflow-on-surface-right": "var(--gradient-overflow-on-surface-right)",
        "overflow-on-surface-left": "var(--gradient-overflow-on-surface-left)",
        "overflow-on-surface-bottom": "var(--gradient-overflow-on-surface-bottom)",
        "overflow-on-surface-top": "var(--gradient-overflow-on-surface-top)",
        "overflow-on-modal-right": "var(--gradient-overflow-on-modal-right)",
        "overflow-on-modal-left": "var(--gradient-overflow-on-modal-left)",
        "overflow-on-modal-bottom": "var(--gradient-overflow-on-modal-bottom)",
        "overflow-on-modal-top": "var(--gradient-overflow-on-modal-top)",
        "overflow-on-body-right": "var(--gradient-overflow-on-body-right)",
        "overflow-on-body-left": "var(--gradient-overflow-on-body-left)",
        "overflow-on-body-bottom": "var(--gradient-overflow-on-body-bottom)",
        "overflow-on-body-top": "var(--gradient-overflow-on-body-top)",
        "zerohash-bg-modal-header": "var(--gradient-zerohash-bg-modal-header)",
        "zerohash-bg-modal-body": "var(--gradient-zerohash-bg-modal-body)",
        "zerohash-bg-surface": "var(--gradient-zerohash-bg-surface)",
        "crypto-surface-02": "var(--gradient-crypto-surface-02)",
        "crypto-surface-01": "var(--gradient-crypto-surface-01)",
        "ai-border-hover": "var(--gradient-ai-border-hover)",
        "ai-border-default": "var(--gradient-ai-border-default)",
        "zero-hash-brand-cam-module": "var(--gradient-zero-hash-brand-cam-module)",
        "zero-hash-brand-cam-bg": "var(--gradient-zero-hash-brand-cam-bg)",
        "zero-hash-brand-modal-header-gradient": "var(--gradient-zero-hash-brand-modal-header-gradient)",
        "zero-hash-brand-modal-bg": "var(--gradient-zero-hash-brand-modal-bg)",
        "zero-hash-brand-web-bg": "var(--gradient-zero-hash-brand-web-bg)",
        "chart-area-negative-gradient": "var(--gradient-chart-area-negative-gradient)",
        "chart-area-positive-gradient": "var(--gradient-chart-area-positive-gradient)",
        "chart-area-neutral-gradient": "var(--gradient-chart-area-neutral-gradient)",
    },
};
